import type { Dispatch, DispatchWithoutAction, SetStateAction } from "react";
import { useCallback, useState } from "react";

export type UseBooleanReturn = {
    value: boolean;
    setValue: Dispatch<SetStateAction<boolean>>;
    setTrue: DispatchWithoutAction;
    setFalse: DispatchWithoutAction;
    toggle: DispatchWithoutAction;
};

export function useBoolean(defaultValue = false): UseBooleanReturn {
    const [value, setValue] = useState(defaultValue);

    const setTrue = useCallback(() => {
        setValue(true);
    }, []);

    const setFalse = useCallback(() => {
        setValue(false);
    }, []);

    const toggle = useCallback(() => {
        setValue(x => !x);
    }, []);

    return { value, setValue, setTrue, setFalse, toggle };
}
